import React from 'react';
import { useTranslation } from 'react-i18next';
import EffectHorizontalChart from './EffectHorizontalChart/EffectHorizontalChart';
import { Wrapper, Table, HeaderCell, HeaderRow } from './EffectProgressTable.styles';
import parseRelatedTopics from '../../../../../helpers/effectReports/parseRelatedTopics';
import { defaultScales } from '../../../../../helpers/helpers';
import { useReportContext } from '../../../../../hooks/useReport';
import { Analysis, IToggleState } from '../../../../../services/reports';

interface ProgressTableProps {
  data: Analysis;
  togglersState: IToggleState;
}

const ProgressTable: React.FC<ProgressTableProps> = ({ data, togglersState }) => {
  const { effectData } = useReportContext();
  const matchingTopics = parseRelatedTopics(data, effectData);

  const { t } = useTranslation();

  return (
    <Wrapper>
      <Table>
        <thead>
          <HeaderRow>
            <HeaderCell>{t('report.effect.table.topic')}</HeaderCell>
            <HeaderCell>{t('report.effect.table.score')}</HeaderCell>
            <HeaderCell></HeaderCell>
            <HeaderCell>
              {defaultScales.map(item => (
                <div key={item}>{item}</div>
              ))}
            </HeaderCell>
          </HeaderRow>
        </thead>
        <tbody>
          {matchingTopics.map(topic => {
            return (
              <EffectHorizontalChart key={topic.code} topic={topic} togglersState={togglersState} />
            );
          })}
        </tbody>
      </Table>
    </Wrapper>
  );
};

export default ProgressTable;
